import { TID } from '@/lib/testIds';
import { ArrowUpRight } from 'lucide-react';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={TID.footer.root}
      className="relative border-t border-white/8 bg-ink overflow-hidden"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 right-1/3 w-[600px] h-[600px] ember-glow opacity-40"
      />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-10">
        <div
          data-testid={TID.footer.display}
          className="font-display font-extrabold text-text tracking-tight leading-[0.88]"
          style={{ fontSize: 'clamp(56px, 15vw, 240px)' }}
        >
          LET&apos;S BUILD
          <br />
          <span className="text-ember">SYSTEMS.</span>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-12 gap-6 md:gap-10 border-t border-white/8 pt-10">
          <div className="col-span-12 md:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.28em] text-text-70 mb-4">
              Sejal Patil
            </p>
            <p className="font-display font-semibold text-text text-2xl md:text-3xl">
              Business &amp; Strategy Consultant
            </p>
            <p className="mt-3 text-[13px] text-text-70 max-w-md">
              Strategy · Operations · Organization · Digital Transformation
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.28em] text-text-70 mb-4">
              Contact
            </p>
            <a
              href="mailto:me@sejalpatil.com"
              data-testid={TID.footer.email}
              className="block text-text hover:text-ember transition-colors mb-2"
            >
              me@sejalpatil.com
            </a>
            <a
              href="tel:+919967762310"
              className="block text-text/85 hover:text-ember transition-colors"
            >
              +91 99677 62310
            </a>
            <p className="mt-2 text-text-70 text-sm">Mumbai, India</p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.28em] text-text-70 mb-4">
              Navigate
            </p>
            <ul className="space-y-2 text-text/85 text-sm">
              <li><a href="#about" className="hover:text-ember">About</a></li>
              <li><a href="#services" className="hover:text-ember">Services</a></li>
              <li><a href="#approach" className="hover:text-ember">Approach</a></li>
              <li><a href="#insights" className="hover:text-ember">Insights</a></li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-2 md:text-right">
            <p className="text-[11px] uppercase tracking-[0.28em] text-text-70 mb-4">
              Social
            </p>
            <a
              href="#"
              data-testid={TID.footer.linkedin}
              className="inline-flex items-center gap-2 text-text hover:text-ember transition-colors"
            >
              LinkedIn <ArrowUpRight size={14} />
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-6 border-t border-white/8">
          <p
            data-testid={TID.footer.copyright}
            className="text-[11px] uppercase tracking-[0.24em] text-text-70"
          >
            © {year} Sejal Patil. All rights reserved.
          </p>
          <p className="text-[11px] uppercase tracking-[0.24em] text-text-70">
            Designed with intention. Built to scale.
          </p>
        </div>
      </div>
    </footer>
  );
}
